import { NgModule } from '@angular/core';
import { CheckRoleDirective } from '../../shared/directives/check-role.directive';

@NgModule({
  declarations: [CheckRoleDirective],
  exports: [CheckRoleDirective],
})
export class DirectivesModule {}
